import EmptyAlert from './EmptyAlert.vue'

export { EmptyAlert }
export default EmptyAlert
